import { useSelector } from 'react-redux'

import pages from '../pages/pages'
import MissingPage from '../pages/MissingPage'

/********************************* 
 * 
 * navigation
 * 
*/
export const selectNavigation = state => state.navigation
export const useNavigation = () => useSelector(selectNavigation)
export const selectPrimary = state => selectNavigation(state).primary
export const usePrimary = () => useSelector(selectPrimary)
export const selectTertiary = state => {
  const {
    tertiary,
    prev: { tertiary: prevTertiary }
  } = selectNavigation(state)
  return { tertiary, prevTertiary }
}
export const selectLocation = state => state.location
export const useReduxLocation = () => useSelector(selectLocation)
export const useTertiary = () => useSelector(selectTertiary)

export const selectStack = state => selectNavigation(state).stack
export const useStack = () => useSelector(selectStack)
export const usePlaceType = () => {
  const stack = useStack()
  const level = stack[stack.length - 1]
  const place = level[level.length - 1]
  return place.type
}

export const useIsModal = () => {
  const navigation = useNavigation()
  const { stack } = navigation
  return stack.reduce((result, level) => {
    return result || level[0].modal
  }, false)
}

const createModalScreenKey = nav => {
  if (nav.length) {
    return nav.reduce((r, p) => (r += p.type + '-'), '')
  } else {
    return '' + Math.random()
  }
}

export const useScreenKey = () => {
  const navigation = useNavigation()
  const modal = useIsModal()
  const { secondary } = navigation
  return modal ? createModalScreenKey(secondary) : 'top'
}

/*********************************
 * 
 *  Page properties
 * 
 */
export const usePage = () => {
  const navigation = useNavigation()

  const { stack } = navigation

  const level = stack[stack.length - 1]
  const place = level[level.length - 1]
  if (!pages[place.type]) {
    console.error(`${place.type} not found in`, Object.getOwnPropertyNames(pages))
  }

  return { page: pages[place.type] || MissingPage, place }
}

export const usePageTitle = () => {
  const { page } = usePage()
  return page.title
}

export const usePageSeconderyNav = () => {
  const { page, place } = usePage()
  return page.getExtraSecondaryNavigation({ place })
}
